<template>
  <div id="login" class="container">
    <div class="content">
        <div class="leftDiv">
            <img src="@/assets/custom-image/login-leftBackImg.svg"/>
            <div class="middle">
                <div class="title">智能万物互联</div>
                <div class="small">海量设备/数据安全通信/云端远程控制</div>
            </div>
        </div>
        <div class="form-cont">
            <div class="topTitle common-textCenter">百仁吉系统管理平台</div>
            <el-form ref="loginForm" :model="loginForm" class="login-form">
                <div class="common-relatives">
                  <el-form-item prop="username">
                    <el-input v-model="loginForm.username" type="text"  prefix-icon="el-icon-s-custom"  onkeyup='value=value.replace(/^\s*|\s*$/g,"")'  auto-complete="off" placeholder="请输入账号" />
                  </el-form-item>
                  <div v-if="hintUsername" class="common-absolute common-left common-bottom textCode">账号不可为空</div>
                </div>
                <div class="common-relatives">
                  <el-form-item prop="password">
                    <el-input v-model="loginForm.password" type="password" :show-password="true" auto-complete="off" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'  prefix-icon="el-icon-lock" placeholder="请输入密码" />
                  </el-form-item>
                  <div v-if="hintPassword" class="common-absolute common-left common-bottom textCode">密码不可为空</div>
                </div>  
                <div class="common-relatives ">
                  <el-form-item prop="code">
                    <div class="common-items-center">
                      <el-input v-model="loginForm.code"     type="text"  onkeyup='value=value.replace(/^\s*|\s*$/g,"")'   auto-complete="off" prefix-icon="el-icon-info" placeholder="请输入验证码" maxlength="4" style="width:244px" />
                      <Code  @getVal="getCode"></Code>
                    </div>
                  </el-form-item>
                  <div v-if="hintCode" class="common-absolute common-left common-bottom textCode">{{hintText}}</div>
                </div>    
                <el-form-item style="width:100%;">
                  <el-button :loading="this.$store.state.loginStade" size="medium" type="primary"  style="width:100%;" @click="submitBtn" >
                    <span v-if="!this.$store.state.loginStade">登 录</span>
                    <span v-else>登 录 中...</span>
                  </el-button>
                </el-form-item>
                <div class="common-space-around warp-rdion">
                    <el-checkbox v-model="loginForm.rememberMe" style="margin:0 0 25px 0;">记住密码</el-checkbox>
                    <span class="line">|</span>
                    <span class="forget" @click="forgetBtn">忘记密码</span>
                </div>
            </el-form>
        </div>
        <ResetPw ref="rest"/>
    </div>
    <div class="beian" @click="toUrl">版权所有©2003-2014 深圳市百仁吉科技 粤ICP备13071615号</div>
  </div>
</template>
<script>
import store from '@/utils/store'
import {rules,url,loginApi} from './../utils/config'
import {login,getFun} from './../utils/httpFun'
import {hex_md5} from './../utils/md5'
import Code from '@/components/component-block/block-ImgCode.vue' 
import ResetPw from '@/components/component-Brow/block-reset.vue'
export default {
  name: 'Login',
  components:{
       Code:Code,
       ResetPw:ResetPw   
  },
  data:()=>({
      loading:false,
      hint:true, 
      hintUsername:false,
      hintPassword:false,
      hintCode:false,
      hintText:"",
      verify:"",
      loginForm: {
          // username:"operate",
          // password:"123456",
          username:"",
          password:"",
          platform:"1",    // 1运维平台
          model:'1',       // 1系统账户
          code:"",
          rememberMe:false
      }
  }),
  created(){
     //检测是否有记住密码
     if(!!localStorage.getItem("YUNWEIBAIRENJIACCOUNT")){
        this.loginForm.username = localStorage.getItem("YUNWEIBAIRENJIACCOUNT")
        this.loginForm.password = localStorage.getItem("YUNWEIBAIRENJIPASSWORD")
        this.loginForm.rememberMe = true
     }else{
        this.loginForm.rememberMe = false
     } 
  },
  mounted(){
    // this.enterKeyup()
    document.addEventListener("keyup",this.keyup)
  },
  beforeDestroy(){
    document.removeEventListener("keyup",this.keyup)
  },
  methods:{
      keyup(e){if(e.code == 'Enter' || e.code=='NumpadEnter'){
        this.submitBtn();
      }},
      //验证用户账号
      validationUseName(){
          if(!rules.NONEMPTY.test(this.loginForm.username)){
             this.hintUsername = true
             return false
          }
          this.hintUsername = false
          return true
      },
      //验证用户密码
      validationPassweord(){
          if(!rules.NONEMPTY.test(this.loginForm.password)){
             this.hintPassword = true
             return false
          }
          this.hintPassword = false
          return true
      },
      //验证验证码
      validationCode(){
        if(!rules.NONEMPTY.test(this.loginForm.code)){
             this.hintCode = true
             this.hintText = "验证码不可为空"
             return false
        }else if(this.loginForm.code+""!=this.verify){
             this.hintCode = true
             this.hintText = "验证码不正确，请重新输入"
             return false
        }
        this.hintText = ""
        this.hintCode = false
        return true
      },

      //用户提交
      submitBtn(){
         let username = this.validationUseName()
         let password = this.validationPassweord()
         let code = this.validationCode()
         let validation = username && password && code
         if(!validation){
             return
         }
         let parms = {
             account:this.loginForm.username,
             password:hex_md5(this.loginForm.password),
             platform:this.loginForm.platform,
             model:this.loginForm.model
         }
        

         //判断是否有勾选记住密码
         if(this.loginForm.rememberMe){
            localStorage.setItem("YUNWEIBAIRENJIACCOUNT",this.loginForm.username)
            localStorage.setItem("YUNWEIBAIRENJIPASSWORD",this.loginForm.password)
         }else{
            localStorage.removeItem("YUNWEIBAIRENJIACCOUNT")
            localStorage.removeItem("YUNWEIBAIRENJIPASSWORD")
         }
         store.commit({
            type: "setloginStade",
            loginStade: true
         })
           
         login(loginApi.LOGIN,parms,res=>{
            localStorage.removeItem("menuBtnVav")
            //登录成功跳转到
            this.$router.replace({
                path:"/Index/Platform",
                query:{}
            })
         })
      },

      //获取验证码
      getCode(ev){
         this.verify = ev
        //  this.verify = "1234"
      },
  
      //键盘事件开始登录
      enterKeyup() {
        document.addEventListener("keyup", this.submitBtn);
      },

      //忘记密码
      forgetBtn(){
         this.$refs.rest.showWindow() 
      },

      toUrl(){
        window.location.href='https://beian.miit.gov.cn/'
      }
  

      //获取左侧菜单

    
      //获取省市数据
      // async getLI(){
      //   let parms = {
      //     key:"b5439f0621e9f1f3a63514d69df4a97a",
      //     subdistrict:3
      //   }
      //   await getFun("https://restapi.amap.com/v3/config/district",parms,res=>{
      //       console.log("结果",res.districts[0].districts)
            
      //   })
      // },

  }
}
</script>
<style lang="scss" scoped>
    @import "~@/assets/custom-css/css-config.scss";
    .container{
          width: inherit;
          height: inherit;
          min-width: 1080px;
          min-height: 620px;
          background-color: $loginBackColor;
          background-image: $loginBackImg;
          background-size: cover;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
        .content{
            display:flex;
            width: 1400px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            .leftDiv{
              position: relative;
              img{
                 height: 500px;
              }
              .middle{
                   position: absolute;
                   top: 179px;
                   left: 508px;
                  .title{
                      width: 198px;
                      height: 42px;
                      font-family: PingFangSC-Semibold;
                      font-size: 30px;
                      color: #1B1B1B;
                      letter-spacing: 3px;
                      font-weight: 600;
                      padding-bottom: 32px;
                  }
                  .small{
                      font-family: PingFangHK-Regular;
                      font-size: 16px;
                      color: #A6A6A6;
                      letter-spacing: 3.56px;
                      font-weight: 400;
                  }
                }
            }
            .form-cont{
                width: 464px;
                height: 602px;
                background: #FFFFFF;
                border-radius: 8px;
                padding: 56px 44px;
                box-sizing: border-box;
                ::v-deep .el-input__inner{
                   height: 50px;
                }
              .topTitle{
                font-family: PingFangSC-Regular;
                color: #4D5C72;
                letter-spacing: 0;
                font-weight: 400;
                font-size: 25px;
                padding-bottom:38px;
              }
              .textCode{
                font-size: 12px;
                bottom: -18px;
                color: #e6a23c;
              }
              .el-form-item{
                margin-bottom: 24px;
              }
              .forget{
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #4D5C72;
                cursor:pointer;
              }
              .warp-rdion{
                 padding: 14px 60px 0 60px;
                 box-sizing: border-box;
                 .line{
                    color: #4D5C72;
                    color: white;
                    display: inline-block;
                    height: 14px;
                    width: 1px;
                    background-color: #4D5C72;
                    margin-top: 4px;
                 }
              }
          }
        }
        ::v-deep .el-input__inner {
          height: 50px !important;
          border: 1px solid rgba(213, 217, 227, 1) !important;
          margin-top: 5px !important;
          font-size: 15px !important;
        }

        ::v-deep .el-form-item {
          margin-bottom: 24px !important;
        }

        ::v-deep .el-input__prefix i {
          font-size: 20px !important;
          margin-top: 5px !important;
        }

        ::v-deep .el-button {
          height: 50px;
          background: #458EFF;
          border-radius: 8px;
        }
        ::v-deep .el-input__suffix-inner{
          position: relative;
          top: 6px;
        }
    } 
    .beian{
       position: fixed;
       bottom: 20px;
       width: 100%;
       text-align:center;
       font-size:14px;
       cursor: pointer;
    }
</style>
